import { timeout, delay } from '@ynap/promise-utils';
import { ResponseError, Person } from '@ynap/api-utils';
import { FETCH_USER_REQUEST, FETCH_USER_SUCCESS, FETCH_USER_ERROR } from '../constants/ActionTypes';
import { push } from 'connected-react-router';

export function fetchUserRequest() {
    return {
        type: FETCH_USER_REQUEST,
    };
}

export function fetchUserSuccess(user) {
    return {
        type: FETCH_USER_SUCCESS,
        body: user,
    };
}

export function fetchUserError() {
    return {
        type: FETCH_USER_ERROR,
    };
}

export function getUserRequest(baseUrl, brandId, country, uberToken, clientId, clientSecret) {
    return Person.getUserDetails({
        baseUrl,
        brandId,
        country,
        uberToken,
        clientId,
        clientSecret,
    });
}

export function getFetchUserRequest(baseUrl, brandId, country, uberToken, clientId, clientSecret, clientRequest) {
    const request = getUserRequest(baseUrl, brandId, country, uberToken, clientId, clientSecret);

    return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay);
}

export default function fetchUser() {
    return (dispatch, getState) => {
        const { locale, config, router, uberToken } = getState();
        const { location = {} } = router;
        const { country } = locale;
        const { pathname } = location;
        const { clientRequest } = config.head || config;
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce;
        const { brandId } = config.watsonService || config.global.application;

        if (!uberToken) {
            return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`));
        }

        dispatch(fetchUserRequest());

        //todo look at if this is shareable across state packages
        return getFetchUserRequest(baseUrl, brandId, country, uberToken, clientId, clientSecret, clientRequest)
            .then((res) => {
                const { ok, status } = res;
                if (ok) {
                    return res.json().then((json) => {
                        if (json.registrationStatus === 'Guest') {
                            return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`));
                        }
                        dispatch(fetchUserSuccess(json));
                    });
                } else if (status === 401) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`));
                }

                throw new ResponseError(res);
            })
            .catch((error) => {
                dispatch(fetchUserError());
                throw error;
            });
    };
}
